import { useEffect, useRef } from 'react';
import { useSideNavVisibility } from '@atlassian/navigation-system/layout/side-nav';
import { useIsFullscreen } from '../fullscreen/index.tsx';

// TODO: clean this up with fg('jira_nav4_remove_internal_sidenav_state_hook')
export const useSidebarVisibilitySync = () => {
	const { visibleOnDesktop, setVisibleOnDesktop } = useSideNavVisibility();
	const wasVisibleOnDesktop = useRef(visibleOnDesktop);
	const [isFullscreenLayout] = useIsFullscreen();
	useEffect(() => {
		if (!isFullscreenLayout) {
			wasVisibleOnDesktop.current = visibleOnDesktop;
		}
	}, [visibleOnDesktop, isFullscreenLayout]);
	useEffect(() => {
		// we only need to close the sidebar if it was open when we entered fullscreen mode
		if (isFullscreenLayout && wasVisibleOnDesktop.current) {
			setVisibleOnDesktop(false);
			// when we leave fullscreen mode, we restore the sidebar visibility to be open if it already was open
			return () => {
				setVisibleOnDesktop(true);
			};
		}
	}, [isFullscreenLayout, setVisibleOnDesktop]);
	// do not sync to the remote state until the "visibleOnDesktop" state has been reverted
	return {
		shouldSyncToRemoteState:
			!isFullscreenLayout && wasVisibleOnDesktop.current === visibleOnDesktop,
	};
};
